import { Navigate, Outlet } from 'react-router-dom';
import { useProjectAssessmentEnabled } from '../../utils/customHooks';
import { HOME } from '../RoutesNomenclature';

// Wraps the project (Innovation Lab) routes. The menu entries are already
// hidden when the school's PROJECT_ASSESSMENT flag is off - this also stops
// deep links and bookmarks from opening the screens.
const ProjectAssessmentRouteGuard = () => {
  const projectAssessmentEnabled = useProjectAssessmentEnabled();
  return projectAssessmentEnabled ? <Outlet /> : <Navigate to={HOME} replace />;
};

export default ProjectAssessmentRouteGuard;
